import type { TextsConfig } from '@/types/texts/texts.types';

export const textConfig: TextsConfig = {
  h1: {
    tag: 'h1',
    class: 'text-h1',
    uppercase: true
  },
  h2: {
    tag: 'h2',
    class: 'text-h2',
    uppercase: true
  },
  h3: {
    tag: 'h3',
    class: 'text-h3',
    uppercase: true
  },
  h4: {
    tag: 'h4',
    class: 'text-h4',
    uppercase: true
  },
  subtitle1: {
    tag: 'p',
    class: 'text-subtitle-1',
    uppercase: true
  },
  subtitle2: {
    tag: 'p',
    class: 'text-subtitle-2',
    uppercase: true
  },
  subtitle3: {
    tag: 'p',
    class: 'text-subtitle-3',
    uppercase: true
  },
  body1: {
    tag: 'p',
    class: 'text-body-1',
    light: true,
    regular: true,
    medium: true,
    bold: true
  },
  body2: {
    tag: 'p',
    class: 'text-body-2',
    light: true,
    regular: true,
    medium: true,
    bold: true
  },
  body3: {
    tag: 'p',
    class: 'text-body-3',
    light: true,
    regular: true,
    medium: true,
    bold: true,
    lightItalic: true
  },
  body4: {
    tag: 'p',
    class: 'text-body-4',
    light: true,
    regular: true,
    medium: true,
    bold: true,
    lightItalic: true
  },
  body5: {
    tag: 'p',
    class: 'text-body-5',
    light: true,
    regular: true,
    medium: true
  },
  button: {
    tag: 'p',
    class: 'text-button',
    regular: true,
    medium: true,
    bold: true
  },
  caption1: {
    tag: 'p',
    class: 'text-caption-1',
    italic: true
  },
  caption2: {
    tag: 'p',
    class: 'text-caption-2',
    thin: true,
    bold: true
  },
  link1: {
    tag: 'p',
    class: 'text-link-1',
    uppercase: true,
    medium: true
  },
  link2: {
    tag: 'p',
    class: 'text-link-2',
    medium: true
  },
  link3: {
    tag: 'p',
    class: 'text-link-3',
    medium: true
  },
  number1: {
    tag: 'p',
    class: 'text-number-1'
  },
  number2: {
    tag: 'p',
    class: 'text-number-2'
  },
  number3: {
    tag: 'p',
    class: 'text-number-3'
  },
  number4: {
    tag: 'p',
    class: 'text-number-4'
  },
  number5: {
    tag: 'p',
    class: 'text-number-5'
  },
  number6: {
    tag: 'p',
    class: 'text-number-6'
  },
  number7: {
    tag: 'p',
    class: 'text-number-7'
  },
  number8: {
    tag: 'p',
    class: 'text-number-8'
  }
};
